import React__default__default from 'react';
import ReactUtils from '../packages/react-utils/react-utils.js';

/**
 * Validates label props based on acceptable Label text prop.
 */
var inputLabelValidator = function (componentName) {
  if (componentName === void 0) {
    componentName = 'Input';
  }
  return function (_a) {
    var ariaLabel = _a["aria-label"],
      label = _a.label;
    if (!ariaLabel && !label) {
      return new Error("".concat(componentName, " component requires either a label or aria-label."));
    }
    if (label && typeof label !== 'string' && ! /*#__PURE__*/React__default__default.isValidElement(label)) {
      return new Error("".concat(componentName, " component only accepts a \"Label\" component or a valid ReactElement as label, but received ").concat(ReactUtils.getElementName(label), "."));
    }
    return null;
  };
};

export { inputLabelValidator };
